__turbopack_context__.v({
  "button": "home-member-card-module__nFiegW__button",
  "card": "home-member-card-module__nFiegW__card",
  "details": "home-member-card-module__nFiegW__details",
  "memberNumber": "home-member-card-module__nFiegW__memberNumber",
  "numberLabel": "home-member-card-module__nFiegW__numberLabel",
  "qrAction": "home-member-card-module__nFiegW__qrAction",
  "qrTile": "home-member-card-module__nFiegW__qrTile",
});
